import { createGlobalStyle } from "styled-components";

export const GlobalStyles = createGlobalStyle`
  body {
    margin: 0;
    padding: 0;
    font-family: Optimistic Display, -apple-system, ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;;
  }

  * {
    box-sizing: border-box;
  }

  a {
    text-decoration: none;
    color: inherit;
  }
  /* Forcer les blocs techniques en LTR même en langue arabe */
  [dir="rtl"] pre,
  [dir="rtl"] code,
  [dir="rtl"] pre *,
  [dir="rtl"] code * {
    direction: ltr;
    text-align: left;
    unicode-bidi: embed;
  }

  [dir="rtl"] p code {
    display: inline-block;
    direction: ltr;
    text-align: left;
  }
`;
